import styled from 'styled-components';

export const DataRow = styled.div`
  display: flex;
  justify-content: space-between;
`;
